<template>
    <div :class="computedClass">
        <select class="langselector__select ff-light uppercase" @change="langChanged($event.target);">
            <option v-for="(lang, index) in langs" :value="[lang.id, lang.value]" v-bind:key="index" :selected="locale === lang.value">
                <!-- :disabled="lang.label === 'fr' && !hasAccessSuperAdmin()" -->
                {{ lang.label }}
            </option>
        </select>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import connectionBO from "../../services/connectionBO";
import cacheService from "@/services/cache";

export default {
    components: {
        connectionBO
    },
    data() {
        return {
            navMobile: this.mobilemenu,
            prefRegistre: {}
        };
    },
    // this prop is for personalise css if le selectorlang is in menu mobile
    props: [
        "mobilemenu",
        "classescss" // this prop is for personalize/overrride styles css
    ],
    methods: {
        ...mapActions({
            setLocale: "i18n/setLocale"
        }),
        langChanged: function(targetElement) {
            let newLang = targetElement.value;
            if (this.getLocale !== newLang) {
                this.setLocale(newLang);
            }
            connectionBO.getPreferences().then(v => {
                this.prefRegistre = v;
                if (v.preference.language.default) {
                    this.prefRegistre.preference.language.id = cacheService.getUserLangId();
                    /**
                     * UPDATE LANGUE Preference
                     */
                    if (typeof this.prefRegistre.preference !== "undefined") {
                        connectionBO.putPreference(this.prefRegistre);
                    }
                }
            });
        }
    },
    computed: {
        computedClass() {
            // @ todo make rafacto, this is darty
            let clsMobile = "langselector select " + this.classescss;
            let clsDesktop = "langselector custom-select " + this.classescss;

            if (this.mobilemenu) {
                return clsMobile;
            }

            return clsDesktop;
        },
        ...mapGetters("i18n", {
            locale: "getLocale",
            langs: "getLangs"
        })
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";
.select {
    padding: 20px 25px 0px 20px;
    select {
        width: 100%;
        font-size: 1.4rem;
        border: none;
        color: black;
    }
}
#menuHeader .langselector__select {
    color: #fff;
    @media only screen and (max-width: 767px) {
        color: black;
    }
}
.langselector__select {
    font-size: 1.4rem;
    /* styling */
    background-color: transparent;
    border-radius: 4px;
    display: inline-block;
    @extend %primary-text;
    line-height: 1.5em;
    padding: 5px 0;
    /* reset */
    margin: 0;
    option {
        color: whitesmoke;
        background-color: black;
        &[disabled] {
            background-color: grey;
        }
    }
}

.langselector--in-plano {
    display: inline-block;
    margin: 0;
    border-right: 1px solid #f3f3f3;
}

.langselector {
    padding-right: 10px;
    &.langselector--in-plano select {
        border-right: 0px solid transparent !important;
        color: #000;
        margin: 10px 0;
    }
}

@media only screen and (max-width: 767px) {
    .custom-select {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// langSelector.vue?c8f2bedc